module.exports = __webpack_public_path__ + "static/media/IT0023W0091.0fe5010.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp4/IT0023W0091.wav
// module id = JBrC
// module chunks = 1